import React from 'react'
import { useConnect } from 'sb-redux-hook'
import { useCallback } from 'sb-hooks'
import { links } from 'common/helpers'
import actions from 'redux/actions'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'

import messages from './messages'


type RedeemButtonProps = Pick<ButtonProps, 'size' | 'color' | 'fullWidth' | 'dataTestId'>

const RedeemButton: React.FunctionComponent<RedeemButtonProps> = (props) => {
  const { size, color, fullWidth, dataTestId } = props

  const { hasMarketingCoupon, giftSubscription } = useConnect({
    hasMarketingCoupon: 'models.me.hasMarketingCoupon',
    giftSubscription: 'models.me.giftSubscription',
  })

  const isGiftSubscriptionActive = giftSubscription && !giftSubscription.activated

  const title = hasMarketingCoupon || !isGiftSubscriptionActive
    ? messages.redeemCoupon
    : messages.redeemGift

  const onClick = useCallback(() => {
    const link = hasMarketingCoupon || !isGiftSubscriptionActive ? links.couponPayment : links.giftRedeem

    actions.models.router.push(link)
  }, [ hasMarketingCoupon, isGiftSubscriptionActive ])

  return (
    <Button
      size={size}
      color={color}
      fullWidth={fullWidth}
      title={title}
      dataTestId={dataTestId}
      onClick={onClick}
    />
  )
}


export default RedeemButton
